import { render, staticRenderFns } from "./shipmentItem.vue?vue&type=template&id=4063565a&scoped=true&"
import script from "./shipmentItem.vue?vue&type=script&lang=js&"
export * from "./shipmentItem.vue?vue&type=script&lang=js&"
import style0 from "./shipmentItem.vue?vue&type=style&index=0&id=4063565a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4063565a",
  null
  
)

export default component.exports